import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getMemberStats = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/member-stat-data`);
};

export const useMemberStats = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["member-stats", churchId],
    queryFn: () => getMemberStats({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
